import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth-context";
import { DataContext } from "../../context/data-context";
import SidebarButton from "../UI/SidebarButton";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toTitleCase } from "../../util/toTitleCase";
import { FaUserCircle } from "react-icons/fa";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useContext(AuthContext);
  const { customers } = useContext(DataContext);
  const [admin, setAdmin] = useState(false);

  // Get page address from url
  const selected = toTitleCase(location.pathname.slice(1).split("/")[0]);

  const selectionHandler = (selected) => {
    navigate(`/${selected.toLowerCase()}`);
  };

  useEffect(() => {
    setAdmin(customers.filter((c) => c.id === user.uid)[0]);
  }, [customers]);

  return (
    <div className="relative hidden w-full px-6 py-12 bg-stone-900 rounded-xl md:block">
      <div className="flex flex-col items-center space-y-2">
        {admin?.photo ? (
          <img src={admin.photo} className="w-16 h-16 rounded-full" />
        ) : (
          <FaUserCircle className="w-16 h-16 text-yellow-600" />
        )}
        {admin ? (
          <p className="text-stone-300">
            {admin.firstName} {admin.lastName}
          </p>
        ) : (
          <p className="text-stone-300">{user.displayName}</p>
        )}
      </div>
      <div className="grid gap-8 mt-16 mb-6">
        <SidebarButton
          title="General"
          selected={selected.length === 0 ? "General" : selected}
          onClick={() => selectionHandler("General")}
        />
        <SidebarButton
          title="Bookings"
          selected={selected}
          onClick={() => selectionHandler("Bookings")}
        />
        <SidebarButton
          title="Customers"
          selected={selected}
          onClick={() => selectionHandler("Customers")}
        />
        <SidebarButton
          title="Partners"
          selected={selected}
          onClick={() => selectionHandler("Partners")}
        />
        <SidebarButton
          title="Vehicles"
          selected={selected}
          onClick={() => selectionHandler("Vehicles")}
        />
        <SidebarButton
          title="Payments"
          selected={selected}
          onClick={() => selectionHandler("Payments")}
        />
        <SidebarButton
          title="Coupons"
          selected={selected}
          onClick={() => selectionHandler("Coupons")}
        />
        <SidebarButton
          title="Invoices"
          selected={selected}
          onClick={() => selectionHandler("Invoices")}
        />
        <SidebarButton
          title="Tolls"
          selected={selected}
          onClick={() => selectionHandler("Tolls")}
        />
        <SidebarButton
          title="Charging"
          selected={selected}
          onClick={() => selectionHandler("Charging")}
        />
        <SidebarButton
          title="Expenses"
          selected={selected}
          onClick={() => selectionHandler("Expenses")}
        />
      </div>
    </div>
  );
}
